import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    islogin: false,
    user: "",
    info: {}
  },
  mutations: {
    logined(state) {
      state.islogin = true;
    },
    inituser(state, res) {
      state.user = res.user;
      state.info = res.info;
    }
  },
  actions: {},
  modules: {}
})
